module.exports = __webpack_public_path__ + "5e559e2cc88c7e949cabeefc806fb9e6.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/eyes/uneven-1.png
// module id = 2212
// module chunks = 0